import React, { ReactElement, useEffect, useRef, useState } from 'react'

import Table from '@instabox/internal-web-ui/components/Table'
import { Device } from '@instabox/lockers-update-common/types'
import { formatISO9075 } from 'date-fns'
import { orderBy } from 'lodash'
import { useParams } from 'react-router-dom'

import fetch from '../../fetch'
import DeviceDetailsButton from '../components/DeviceDetailsButton'
import TableActionsContainer from '../components/TableActionsContainer'

interface PackageVersionParams {
  packageId: string
  version: string
}

function PackageVersion(): ReactElement {
  const { packageId, version }: PackageVersionParams = useParams()
  const containerRef = useRef<HTMLDivElement>(null)

  const [devices, setDevices] = useState<Device[]>([])
  const [loading, setLoading] = useState<boolean>(false)

  useEffect(() => {
    const getDevices = async (): Promise<void> => {
      setLoading(true)

      try {
        const response = await fetch(`/api/package/${packageId}/${version}/devices`)

        if (!response.ok) {
          throw new Error(`Unable to get packages: ${response.status} ${response.statusText}`)
        }

        const data = await response.json()

        setDevices(data)
      } finally {
        setLoading(false)
      }
    }

    getDevices().catch(console.error)
  }, [packageId, version])

  const rows = devices ?? []
  const sortedRows = orderBy(rows, (device) => device.updatedAt, 'desc')

  return (
    <div ref={containerRef}>
      <h3>
        {packageId} : {version}
      </h3>
      <Table
        isLoading={loading}
        headers={{
          deviceName: 'Name',
          deviceId: 'Id',
          updatedAt: 'Updated at',
          actions: '',
        }}
        rows={sortedRows.map((device) => ({
          ...device,
          updatedAt: formatISO9075(new Date(device.updatedAt as Date)),
          disableCheckbox: true,
          actions: (
            <TableActionsContainer>
              <DeviceDetailsButton deviceId={device.deviceId} />
            </TableActionsContainer>
          ),
        }))}
      />
    </div>
  )
}

export default PackageVersion
